module.exports = __webpack_public_path__ + "static/media/telefono.48b116ac.webp";